import { AvailabilityEnum } from '../../products/ProductTypes';
import { CatalogAvailabilityConditions } from '../catalog.types';

export const formattedAvailabilityConditions = (
  availabilityConditions?: CatalogAvailabilityConditions,
): CatalogAvailabilityConditions | null => {
  if (!availabilityConditions) {
    return null;
  }

  const formatted = Object.entries(availabilityConditions).reduce((acc, [key, value]) => {
    if (!value) {
      return acc;
    }

    const conditions = {
      ...(value.minTotalPieces &&
        Number(value.minTotalPieces) > 0 && {
          minTotalPieces: Number(value.minTotalPieces),
        }),
      ...(value.minSequentialSizes &&
        Number(value.minSequentialSizes) > 0 && {
          minSequentialSizes: Number(value.minSequentialSizes),
        }),
    };

    if (Object.keys(conditions).length > 0) {
      acc[key as AvailabilityEnum] = conditions;
    }

    return acc;
  }, {} as CatalogAvailabilityConditions);

  return Object.keys(formatted).length > 0 ? formatted : null;
};
